import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AddStateMobileStep3 } from "./add_state_mobile";
import {API_BASE_URL} from "../config.js";
import "./add_state.css";
export default function AddState3() {
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state || {};

  const [diagnose, setDiagnose] = useState("");
  const [diagnosisDate, setDiagnosisDate] = useState(new Date());
  const [maritalStatus, setMaritalStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const { patientId, diseaseCode, status, weight, height } = formData;

    if (!patientId) {
      alert("No patient selected. Please go back to the beginning.");
      return;
    }
    setIsSubmitting(true);

    const formattedDiagnosisDate = diagnosisDate ? new Date(diagnosisDate).toISOString().split('T')[0] : null;
    const doctorId = localStorage.getItem("doctor_id");

    const visitData = {
      disease_code: diseaseCode,
      status: status,
      weight: weight,
      height: height,
      diagnose: diagnose,
      diagnosis_date: formattedDiagnosisDate,
      marital_status: maritalStatus,
      doctor_id: doctorId,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/patients/${patientId}/visits/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("access_token")}`
        },
        body: JSON.stringify(visitData),
      });

      if (response.status === 201) {
        alert("Case added successfully!");
        navigate("/Main");
      } else {
        const errorData = await response.json();
        console.error("Failed to create case:", errorData);
        alert(`Error: Could not add case. ${JSON.stringify(errorData)}`);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      alert("An error occurred while adding the case.");
      setIsSubmitting(false);
    }
  };

  if (isMobile) {
    return (
      <AddStateMobileStep3 
          diagnose={diagnose}
          setDiagnose={setDiagnose}
          diagnosisDate={diagnosisDate}
          setDiagnosisDate={setDiagnosisDate}
          maritalStatus={maritalStatus}
          setMaritalStatus={setMaritalStatus}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          onBack={() => navigate("/add-state-step2", { state: formData })}
      />
    );
  }

  return (
    <div className="add-state-container" dir="rtl">
      <img className='syria-logo-add-state-logo' src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="My Image" />
      <div className="add-state-title">إضافة حالة</div>
      <div className="add-state-stepper3">
              <div className="add-state3" onClick={() => navigate("/add-state", { state: formData })}>1</div>
              <div className="add-state-stepper-line"></div>
              <div className="add-state3" onClick={() => navigate("/add-state-step2", { state: formData })}>2</div>
              <div className="add-state-stepper-line"></div>
              <div className="add-state3-as-step-active">3</div>
      </div>
      <form className="add-state-form" onSubmit={handleSubmit}>
        
        {/* Fields from previous steps are in memory, now we add the final required fields */}
        <label>*التشخيص التفصيلي</label>
        <input className="add-state-input" placeholder="ادخل تفاصيل التشخيص" value={diagnose} onChange={(e) => setDiagnose(e.target.value)} />

        <label>*تاريخ التشخيص</label>
        <DatePicker selected={diagnosisDate} onChange={(date) => setDiagnosisDate(date)} dateFormat="yyyy-MM-dd" className="add-state-input" required/>
        
        <label>*الحالة الاجتماعية</label>
        <div className="add-state-state-radio-group">
            <label className="add-state-radio"><input type="radio" name="marital_status" value="single" checked={maritalStatus === 'single'} onChange={(e) => setMaritalStatus(e.target.value)}/>أعزب</label>
            <label className="add-state-radio"><input type="radio" name="marital_status" value="married" checked={maritalStatus === 'married'} onChange={(e) => setMaritalStatus(e.target.value)}/>متزوج</label>
            <label className="add-state-radio"><input type="radio" name="marital_status" value="divorced" checked={maritalStatus === 'divorced'} onChange={(e) => setMaritalStatus(e.target.value)}/>مطلق</label>
            <label className="add-state-radio"><input type="radio" name="marital_status" value="widow(er)" checked={maritalStatus === 'widow(er)'} onChange={(e) => setMaritalStatus(e.target.value)}/>أرمل</label>
        </div>


        <div className="add-state-title-form"><h2>التحاليل المرفقة (اختياري)</h2></div>
        
        <label className="add-state-label">سرعة الترسيب</label>
        <input className="add-state-input-footsteps" disabled/>

        <div className="add-state-grid">
            <div className="add-state-grid-item">
              <label className="add-state-label">عدد كريات الدم البيضاء</label>
              <input className="add-state-input" disabled/>
            </div>
            <div className="add-state-grid-item">
              <label className="add-state-label">عدد كريات الدم الحمراء</label>
              <input className="add-state-input" disabled/>
            </div>
        </div>
        
        <div className="add-state-actions">
            <button type="submit" className="add-state-btn-primary" disabled={isSubmitting}>{isSubmitting ? "جاري الإضافة..." : "إضافة"}</button>
        </div>
      </form>
    </div>
    );
}
